module.exports = __webpack_public_path__ + "static/media/W1.518727ea.jpg";